import { IOnInit, IPromise } from "angular";
import { MachineConfiguration } from "../../models/machineConfiguration";
import {
  MachinesChangeViewModalService,
  vsServiceName as MachinesChangeViewModalServiceName,
} from "../changeDetailsModel";
import {
  vsName as serverUtilityName,
  ServerUtility,
} from "../../../../records/server/serverUtility";
import { StateService } from "@uirouter/angularjs";
import {
  AuthorizedUiElementConfig,
  AuthorizedUiElementService,
} from "../../../../ui/authorizedUiElement";
import { vsServiceName as MachineDetailTabsServiceName } from "../views/machines/detail/tabs";
import { $confirm } from "../../../../../@custom_types/confirm";
import { Machine } from "../../models/machine";
export class MachineConfigurationViewController implements IOnInit {
  static $inject = [
    MachinesChangeViewModalServiceName,
    serverUtilityName,
    "$state",
    "$confirm",
    MachineDetailTabsServiceName,
  ];

  /*bindings*/
  machineConfiguration!: MachineConfiguration;
  machine!: Machine<MachineConfiguration>;
  /* end bindings */

  constructor(
    private readonly machineChangeViewModalService: MachinesChangeViewModalService,
    private readonly serverUtility: ServerUtility,
    private readonly $state: StateService,
    private readonly $confirm: $confirm,
    private readonly machineDetailTabs: AuthorizedUiElementService<AuthorizedUiElementConfig>
  ) {}

  $onInit(): void {}

  ChangeLog(): IPromise<void> {
    return this.machineChangeViewModalService.openModal(
      this.machineConfiguration?.ChangeId
    ).result;
  }
  deleteConfiguration(): void {
    const { Id } = this.machineConfiguration;

    const lastConfiguration =
      (this.machine.Configs ?? []).find((c) => c.Id !== Id) === undefined;

    this.$confirm({
      text: lastConfiguration
        ? `Because this is the last configuration on this machine, deleting this configuration will result in the machine being deleted as well.
Are you sure you want to delete this configuration and machine?`
        : "Are you sure you want to delete this configuration?",
    }).then(() => {
      {
        this.serverUtility
          .sendApiRequest({
            method: "delete",
            url: `api/machines/MachineConfiguration/${Id}`,
          })
          .then(() => {
            if (lastConfiguration) {
              this.$state.go("main.machines.grid");
            } else {
              this.machineDetailTabs.navigateToChildByIndex(
                0,
                { machineId: this.machineConfiguration.MachineId },
                true
              );
            }
          });
      }
    });
  }
  getStateParams() {
    const machineConfiguration = this.machineConfiguration;
    return {
      machineId: machineConfiguration.MachineId,
      machineConfigurationId: machineConfiguration.Id,
    };
  }
}
